import { createReducer, on } from '@ngrx/store';
import { ExpenseTypeActions } from './expense-type.actions';
import { ExpenseTypeItem } from '@core/interface/expense-type';
import { Pagination } from '@core/interface/core';

export interface ExpenseTypeState {
  expenseTypes: ExpenseTypeItem[];
  isLoading: boolean;
  loadError?: any;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: ExpenseTypeState = {
  expenseTypes: [],
  isLoading: true,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const ExpenseTypeReducer = createReducer(
  initialState,
  on(ExpenseTypeActions.loadExpenseTypes, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(
    ExpenseTypeActions.loadExpenseTypesSuccess,
    (state, { data, pagination }) => {
      const rows = data || [];
      return {
        ...state,
        pagination: pagination ?? {
          current_page: 1,
          last_page: 1,
          per_page: rows.length || state.pagination.per_page,
          total: rows.length,
        },
        expenseTypes: rows,
        isLoading: false,
        loadError: null,
      };
    }
  ),
  on(ExpenseTypeActions.loadExpenseTypesFailure, (state, { error }) => ({
    ...state,
    loadError: error,
    isLoading: false,
  })),
  on(ExpenseTypeActions.addExpenseTypeSuccess, (state, { data }) => ({
    ...state,
    expenseTypes: [...state.expenseTypes, data],
    addEditError: null,
  })),
  on(ExpenseTypeActions.addExpenseTypeFailure, (state, error) => ({
    ...state,
    addEditError: error,
  })),
  on(ExpenseTypeActions.updateExpenseTypeSuccess, (state, { data }) => ({
    ...state,
    expenseTypes: state.expenseTypes.map((item) =>
      data.id == item.id ? data : item
    ),
    addEditError: null,
  })),
  on(ExpenseTypeActions.updateExpenseTypeFailure, (state, { error }) => ({
    ...state,
    addEditError: error,
  })),
  on(ExpenseTypeActions.resetExpenseTypes, (state) => ({
    ...state,
    pagination: {
      current_page: 0,
      last_page: 0,
      per_page: 10,
      total: 0,
    },
    expenseTypes: [],
    isLoading: false,
  }))
);
